<template>
  <component
    v-if="paymentProviderType"
    v-show="showPaymentHandler"
    ref="payComponent"

    :console-debug="consoleDebug"

    :is="paymentProviderComponent"
    :location="location"
    :payment-provider-public-options="paymentProviderPublicOptions"
    @payment-reload-timer-completed="paymentReloadTimerCompleted"
    @scroll-up-for-3ds-check="scrollToChooseTabs"
    @scroll-payment-div-into-view="scrollPaymentDivIntoView"
    v-on="$listeners"/>
</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    showPaymentHandler: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      paymentProviderType: null,
      paymentProviderComponent: 'PayNull',
      paymentProviderPublicOptions: {},

      loadingLocationPaymentProvider: false,
      awaitingSalePayment: null,
    };
  },

  watch: {
    loadingLocationPaymentProvider(newLoadingLocationPaymentProvider, oldLoadingLocationPaymentProvider) {
      if (oldLoadingLocationPaymentProvider === true && newLoadingLocationPaymentProvider === false) {
        // we are waiting on loadLocationPaymentProvider to resolve
        if (this.consoleDebug) console.log('PayHandlerIframe::watch(loadingLocationPaymentProvider) - if is TRUE');
        if (this.awaitingSalePayment) {
          if (this.consoleDebug) console.log('PayHandlerIframe::watch(loadingLocationPaymentProvider) - going to to takeSalePayment again');
          this.takeSalePayment(this.awaitingSalePayment.sale, this.awaitingSalePayment.voucherDiscountObject, this.awaitingSalePayment.allowDepositFlag);
          this.awaitingSalePayment = null;
        }
      }
    },
  },

  methods: {
    /* ===============
     * public methods
     */

    saleRefreshed(sale) {
      if (this.consoleDebug) console.log('PayHandlerIframe::saleRefreshed', sale);
      this.$refs.payComponent.saleRefreshed(sale);
    },

    addVouchersToSale(newVouchersToSpend) {
      if (this.consoleDebug) console.log('PayHandlerIframe::addVouchersToSale', newVouchersToSpend);
      this.$refs.payComponent.addVouchersToSale(newVouchersToSpend); // payHandlerIframe needs this array
    },

    takeSalePayment(sale, voucherDiscountObject, allowDepositFlag) {
      if (this.consoleDebug) console.log('PayHandlerIframe::takeSalePayment', sale, voucherDiscountObject, allowDepositFlag);
      if (this.consoleDebug) console.log('PayHandlerIframe::takeSalePayment - this.paymentProviderType', this.paymentProviderType);
      if (this.consoleDebug) console.log('PayHandlerIframe::takeSalePayment - this.showPaymentHandler', this.showPaymentHandler);

      if (this.loadingLocationPaymentProvider) {
        if (this.consoleDebug) console.log('PayHandlerIframe::takeSalePayment - this.loadingLocationPaymentProvider', this.loadingLocationPaymentProvider);
        this.awaitingSalePayment = {sale: sale, voucherDiscountObject: voucherDiscountObject, allowDepositFlag: allowDepositFlag};
        return false;
      }

      if (this.paymentProviderType == null) {
        if (this.consoleDebug) console.log('PayHandlerIframe::takeSalePayment - this.loadingLocationPaymentProvider == null');
        return;
      }

      this.$nextTick(() => {
        if (this.consoleDebug) console.log('PayHandlerIframe::takeSalePayment - $nextTick fired for this.$refs.payComponent.takeSalePayment(...)');
        this.$refs.payComponent.takeSalePayment(sale, voucherDiscountObject, allowDepositFlag);
      });

    },

    takeBookingPayment(booking) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeBookingPayment(booking);
    },

    takeVoucherPayment(voucher) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeVoucherPayment(voucher);
    },

    takeVirtualGamePayment(virtualGame, sale, from) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeVirtualGamePayment(virtualGame, sale, from);
    },

    /*
     * END public methods
     * =============== */

    scrollToChooseTabs() {
      if (this.consoleDebug) console.log('PayHandlerIframe::scrollToChooseTabs');
      this.$emit('scroll-to-choose-tabs');
    },

    paymentReloadTimerCompleted(txAmount) {
      if (this.consoleDebug) console.log('PayHandlerIframe::paymentReloadTimerCompleted, payment-reload-timer-completed about to be emitted', txAmount);
      this.$emit('payment-process-completed', txAmount);
    },

    loadLocationPaymentProvider() {
      if (this.consoleDebug) console.log('PayHandlerIframe::loadLocationPaymentProvider');
      this.loadingLocationPaymentProvider = true;
      axios.get(this.route('api.locations.payment-provider.public', this.location))
        .then((response) => {
          if (this.consoleDebug) console.log('PayHandlerIframe::loadLocationPaymentProvider response back', response.data);
          this.loadingLocationPaymentProvider = false;
          if (response.status == 200) {
            this.paymentProviderPublicOptions = response.data.publicOptions;
            this.paymentProviderComponent = response.data.component + 'Iframe';
            this.paymentProviderType = response.data.type;
          } else {
            flash('Error loading Location PaymentProvider', 'error');
            console.log('loadLocationPaymentProvider', response.data);
            console.log('loadLocationPaymentProvider', response.status);
            console.log('loadLocationPaymentProvider', response.statusText);
          }
        })
        .catch((error) => {
          flash('Error loading Location PaymentProvider', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('loadLocationPaymentProvider:422', error.response.data);
              // TODO: if The email has already been taken. ???
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('loadLocationPaymentProvider:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('loadLocationPaymentProvider:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('loadLocationPaymentProvider:401', error.response.data);
            } else {
              console.log('loadLocationPaymentProvider: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('loadLocationPaymentProvider: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('loadLocationPaymentProvider: Error', error.message);
          }
        });
    },

    scrollPaymentDivIntoView() {
      this.$emit('scroll-to-payment-div');
    },
  },

  mounted() {
    this.loadLocationPaymentProvider();
  },
}
</script>
